// tslint:disable:max-line-length

import React from 'react';

export const ArrowUp = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <polygon points="15.5,8 8,0.5 0.5,8 1.9,9.4 7,4.2 7,15.5 9,15.5 9,4.2 14.1,9.4" />
    </svg>
  );
};
